<tapestry-icon-button
    mat-button
    [matMenuTriggerFor]="search"
    #searchMenuTrigger="matMenuTrigger"
    (onMenuOpen)="menuOpened()"
    (onMenuClose)="menuClosed()"
    iconName="search_bold"
    [altText]="'globalnav.searchMenu-altText' | translate"
    piTesting="global-search-button"
></tapestry-icon-button>
<mat-menu #search="matMenu" class="tapestry-dropdown-menu">
    <div class="searchBoxDropdown">
        <tapestry-icon
            matPrefix
            class="searchIcon"
            name="search"
            [size]="iconSize.Medium"
        ></tapestry-icon>
        <input
            #searchBox
            matInput
            class="searchInput"
            [placeholder]="'globalnav.searchMenu-placeholder:' | translate"
            [(ngModel)]="searchValue"
            (ngModelChange)="searchFunction()"
            (click)="$event.stopPropagation()"
            (keydown.enter)="selectViewMore()"
            piTesting="global-search-input"
            data-tracking="global-search-input"
        />
    </div>
    @for (
        result of results.slice(0, maxDisplayResults);
        track result;
        let i = $index
    ) {
        <button
            mat-menu-item
            class="list-items"
            (click)="selectResult(result)"
            [attr.aria-label]="result.displayName"
            [piTesting]="'search-result' + i"
            matTooltip="{{ result.displayName }}"
            [matTooltipDisabled]="
                result.displayName.length < truncatedTextLength
            "
        >
            @if (result.icon) {
                <tapestry-icon
                    class="pi-icon"
                    [name]="result.icon"
                ></tapestry-icon>
            }
            <span>{{ result.displayName }}</span>
        </button>
    }
    @if (results.length === 0 && searchValue.length > minChars) {
        <button
            mat-menu-item
            class="list-items"
            (click)="selectViewMore()"
            [attr.aria-label]="'globalnav.searchMenu-noResults' | translate"
            piTesting="global-search-no-results"
        >
            {{ 'globalnav.searchMenu-noResults' | translate }}
        </button>
    }
    @if (results.length > maxDisplayResults) {
        <button
            mat-menu-item
            class="list-items"
            (click)="selectViewMore()"
            [attr.aria-label]="'globalnav.searchMenu-viewMore' | translate"
            piTesting="global-search-view-more"
        >
            {{ 'globalnav.searchMenu-viewMore' | translate }}
        </button>
    }
</mat-menu>
